import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DebugAuth = () => {
  const [debugInfo, setDebugInfo] = useState({});

  useEffect(() => {
    const info = {
      fullUrl: window.location.href,
      pathname: window.location.pathname,
      hash: window.location.hash,
      search: window.location.search,
      sessionToken: localStorage.getItem('session_token')
    };
    
    // Try to extract session_id
    const hash = window.location.hash;
    const sessionIdFromHash = hash.match(/session_id=([^&]+)/);
    const searchParams = new URLSearchParams(window.location.search);
    const sessionIdFromSearch = searchParams.get('session_id');
    
    info.sessionIdFromHash = sessionIdFromHash ? sessionIdFromHash[1] : null;
    info.sessionIdFromSearch = sessionIdFromSearch;
    
    setDebugInfo(info);
  }, []);

  const testAuth = async () => {
    const sessionId = debugInfo.sessionIdFromHash || debugInfo.sessionIdFromSearch;
    if (!sessionId) {
      alert('No session_id found in URL');
      return;
    }

    try {
      const response = await axios.post(`${API}/auth/session`, null, {
        headers: { 'X-Session-ID': sessionId }
      });
      alert('Auth successful! User: ' + response.data.user.email);
      localStorage.setItem('session_token', response.data.session_token);
    } catch (error) {
      alert('Auth failed: ' + error.message);
      console.error(error);
    }
  };

  return (
    <div style={{ padding: '20px', background: '#1a1a1a', color: 'white', minHeight: '100vh' }}>
      <h1>Auth Debug Page</h1>
      <pre style={{ background: '#2a2a2a', padding: '15px', borderRadius: '8px' }}>
        {JSON.stringify(debugInfo, null, 2)}
      </pre>
      <button 
        onClick={testAuth}
        style={{ 
          marginTop: '20px', 
          padding: '10px 20px', 
          background: '#4CAF50', 
          color: 'white', 
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer'
        }}
      >
        Test Auth with Session ID
      </button>
    </div>
  );
};

export default DebugAuth;
